import { checkLinkAndAppendLanguage } from './localization';

const roadblockMessageName = 'mobile_roadblock';

const onRoadblockedClick = (messagingChannel, event, currentUser, afterRoadblock, options) => {
  const returnToUrl = options && options.returnToUrl ? options.returnToUrl : window.location.pathname + window.location.search;
  const atRef = options && options.atRef ? options.atRef : undefined;
  const openInNewTab = !!(options && options.openInNewTab);

  messagingChannel.publish(roadblockMessageName, {
    event,
    currentUser,
    atRef,
    afterRoadblock,
    returnToUrl,
    openInNewTab
  });
};

const buildSignupUrl = (href, atRef) => {
  const ref = atRef ? `ref=${atRef}&` : '';
  const returnTo = `returnTo=${encodeURIComponent(href)}`;
  return checkLinkAndAppendLanguage(`/signup?${ref}${returnTo}`);
};

const buildNonRoadblockedUrl = (href, atRef) => {
  const ref = atRef ? `${href.indexOf('?') === -1 ? '?' : '&'}ref=${atRef}` : '';
  return checkLinkAndAppendLanguage(`${href}${ref}`);
};

export { roadblockMessageName, onRoadblockedClick, buildSignupUrl, buildNonRoadblockedUrl };
